export default class Header {

	/** @var {Element} header */
	#header

	/** @var {Number} scrollThreshold */
	#scrollThreshold;

	/** @var {Boolean} scrolled */
	#scrolled = false;

	constructor() {
		this.#header = document.querySelector('header.header');
		if (!this.#header) {
			return;
		}

		this.#scrollThreshold = Math.floor(window.innerHeight * 0.3);
		this.onScroll();

		window.addEventListener('scroll', () => this.onScroll());

		let menuOpen = false;
		const menuToggle = document.querySelector('button.header-hamburger');
		if (!menuToggle) {
			return;
		}
		menuToggle.addEventListener('click', () => {
			menuToggle.classList.toggle('open');
			menuOpen = !menuOpen;
			this.#header.classList.add('menu-transition');
			window.setTimeout(() => {
				this.#header.classList.remove('menu-transition');
				this.#header.classList.toggle('menu-open', menuOpen);
				this.#header.classList.toggle('menu-closed', !menuOpen);
			}, 300);
		});
	}

	onScroll() {
		const updatedScrollState = window.scrollY > this.#scrollThreshold;
		if (updatedScrollState === this.#scrolled) {
			return;
		}
		this.#scrolled = updatedScrollState;
		this.#header.classList.toggle('scrolled', this.#scrolled);
	}

}
